import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import injectSheet from 'react-jss';
import ConnectionList from './connection-list';
import InboxConvList from '../messaging/conversations/convsContainer';
import InboxContent from '../messaging/singleConv/rgtMsgsRouter';
import WorkspaceContent from './content';
import { getConnections, selectConnection, selectChannel, resetChannel, selectContract, changeSelection } from './store/actions';
import { styles as contentStyles } from './content';
import PlaceHolder from './placeholder';
import MassMessagingList from '../massmessaging/workspace/list';
import MassMessagingBody from '../massmessaging/workspace/body';

const styles = {
  container: {
    marginTop: '65px',
    backgroundColor: 'white',
    borderRight: '1px solid rgb(224, 224, 224)',
    borderLeft: '1px solid rgb(224, 224, 224)',
    display: 'flex',
    paddingLeft: '',
    height: 'calc(100% - 65px)',
    marginRight: '60px',
    marginLeft: '60px',
  },
  connectionList: {
    flex: '0 0 auto',
    width: '294px',
    height: '100%',
    backgroundColor: 'rgb(240, 240, 240)',
    display: 'flex',
    flexDirection: 'column',
  },
  channelList: {
    flex: '0 0 auto',
  },
  body: {
    flex: '3 1 auto',
  },
  ContractContent: contentStyles.content,
  ContractContentMessages: {
    overflowY: 'scroll',
    overflowX: 'hidden',
    marginTop: '-7px',
    padding: '5px',
    height: 'calc(100% - 257px)',
    backgroundColor: 'white',
  },
  ContractContentMessageBox: {
    '& div': {
      marginTop: '0 !important',
    },
  },
  InboxConvList: {},
  InboxContent: {
    height: '100%',
    backgroundColor: 'rgb(250, 250, 250)',
  },
};

class Workspace extends Component {
  componentWillMount() {
    this.syncPropsFromUrl(this.props);
  }
  componentDidMount() {
    this.props.getConnections();
  }
  componentWillReceiveProps(newProps) {
    this.syncPropsFromUrl(newProps);
  }
  syncPropsFromUrl(props) {
    const urlVals = {
      connectionId: props.params.connectionId || null,
      channelId: props.params.channelId || null,
    };
    // sync Url to Store (all values)
    if (
      props.selectedConnection !== urlVals.connectionId ||
      props.selectedChannel !== urlVals.channelId
    ) {
      this.props.changeSelection(urlVals.connectionId, urlVals.channelId);
    }
  }
  render() {
    const { params, classes, connections } = this.props;
    const { connectionId } = params;
    if (connections.length === 0) return <PlaceHolder />;
    return (
      <div className={`${classes.container}`}>
          <ConnectionList className={classes.connectionList}/>
          {/* inbox */}
          { connectionId === 'inbox' ? <InboxConvList params={params} className={classes.InboxConvList}/> : undefined }
          { connectionId === 'inbox' ? <InboxContent params={this.props.params} className={classes.InboxContent}/> : undefined }
          {/* bulk messages */}
          { connectionId === 'bulkmessages' ? <MassMessagingList /> : undefined }
          { connectionId === 'bulkmessages' ? <MassMessagingBody /> : undefined }
          {/* default */}
          { ['inbox', 'bulkmessages'].indexOf(connectionId) < 0 ? <WorkspaceContent className={classes.body}/> : undefined}
      </div>
    );
  }

}

Workspace.propTypes = {
  children: PropTypes.any,
  changeSelection: PropTypes.func,
  classes: PropTypes.object,
  connections: PropTypes.array,
  getConnections: PropTypes.func,
  params: PropTypes.shape({
    connectionId: PropTypes.string,
    channelId: PropTypes.string,
  }),
  selectChannel: PropTypes.func,
  selectConnection: PropTypes.func,
  selectContract: PropTypes.func,
  selectedChannel: PropTypes.string,
  selectedContractId: PropTypes.string,
};

const select = (state) => ({
  user: state.user.toJS(),
  selectedConnection: state.workspace.selectedConnection,
  selectedChannel: state.workspace.selectedChannel,
  selectedContract: state.workspace.selectedContract,
  connections: state.workspace.connections,
});

export default connect(select, {
  getConnections,
  selectConnection,
  selectChannel,
  selectContract,
  resetChannel,
  changeSelection,
})(injectSheet(styles)(Workspace));



// WEBPACK FOOTER //
// ./src/app/components/workspace/container.jsx